import { render, staticRenderFns } from "./BlCopyPop.vue?vue&type=template&id=798c9b84&scoped=true"
import script from "./BlCopyPop.vue?vue&type=script&lang=js"
export * from "./BlCopyPop.vue?vue&type=script&lang=js"
import style0 from "./BlCopyPop.vue?vue&type=style&index=0&id=798c9b84&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798c9b84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('798c9b84')) {
      api.createRecord('798c9b84', component.options)
    } else {
      api.reload('798c9b84', component.options)
    }
    module.hot.accept("./BlCopyPop.vue?vue&type=template&id=798c9b84&scoped=true", function () {
      api.rerender('798c9b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pdf/popup/BlCopyPop.vue"
export default component.exports